import { AmplifyTheme } from "aws-amplify-react";
import { importAll } from "../../helpers/Utils";

const images = importAll(require.context("../../../public/assets/img/pix-zip", false, /\.(png|jpe?g|svg)$/));

const mySectionHeader = {
  backgroundColor: "rgba(224, 48, 119, 1)"
};

const myformSection = {
  // textAlign: 'center',
  /* margin-top: 20px; */
  marginTop: "75px"
};

const myButton = {
  backgroundColor: "rgba(224, 48, 119, 1)",
  color: "rgba(255,255,255)"
};

const myToast = {
  zIndex: 999999,
  backgroundColor: "rgba(224, 48, 119, 1)"
};

const myContainer = {
  backgroundImage: `url(${images[Math.floor(Math.random() * images.length)]})`,
  // backgroundImage: `url(
  //   ${require.context(
  //     '../../../public/assets/img/pix-zip/57e9dc404d52a814f6da8c7dda793e7b143fd9e7574c704c732c78d1964fc65f_1280.jpg',
  //     false,
  //     /\.(png|jpe?g|svg)$/
  //   )}
  // )`,
  backgroundPosition: "50% 50%",
  backgroundSize: "cover"
};

const MyAmplifyTheme = Object.assign({}, AmplifyTheme, {
  button: { ...AmplifyTheme.button, ...myButton },
  sectionHeader: { ...AmplifyTheme.sectionHeader, ...mySectionHeader },
  container: { ...AmplifyTheme.container, ...myContainer },
  toast: { ...AmplifyTheme.toast, ...myToast },
  formSection: { ...myformSection }
});

export default MyAmplifyTheme;
